import { useCallback } from 'react';
import { faArrowUpRightFromSquare } from '@fortawesome/sharp-regular-svg-icons/faArrowUpRightFromSquare';

import { Divider } from 'ui-components/components/divider';
import { FlexColumn, FlexRow } from 'ui-components/components/flex';
import { Text, TextType } from 'ui-components/components/text';

import { FilterEditorContextProvider } from '../../components/filter-editor/context';
import { HelpArticleLink } from '../../components/help-article-link';
import { AUTOMATION_HUB_LEARN_MORE_CLICKED } from '../../constants/analytics-events';
import { linkIDs } from '../../services/link-service/links';
import { Segment } from '../../services/analytics-services/segment';
import { AutomationRulesProvider } from '../settings/automation-rules/context';

import { AutomationPlaybooks } from './components/automation-playbooks/automation-playbooks';
import { AutomationTools } from './components/automation-tools/automation-tools';
import { useBackfillAutomationsSellerSettings } from './hooks/use-backfill-automations-seller-settings';
import { messages } from './messages';
import style from './automations-page.module.less';

import type React from 'react';

export const AutomationsPage: React.FC = () => {
  useBackfillAutomationsSellerSettings();

  const trackLearnMoreClick = useCallback(() => {
    Segment.trackEvent(AUTOMATION_HUB_LEARN_MORE_CLICKED, {});
  }, []);

  return (
    <AutomationRulesProvider>
      <FilterEditorContextProvider>
        <div className={style['automations-page']}>
          <FlexColumn className={style['automations-background']}>
            <FlexColumn className={style['automations-container']}>
              <Text className={style['page-title']} textType={TextType.H1} value={messages.pageTitle} />

              <Text className={style['section-title']} textType={TextType.H4} value={messages.automationPlaybookTitle} />
              <Divider className={style.divider} />
              <AutomationPlaybooks />

              <FlexRow className={style['tools-section-header']}>
                <Text textType={TextType.H4} value={messages.automationToolsTitle} />
                <HelpArticleLink
                  articleId={linkIDs.AutomationHubTools}
                  className={style['learn-more-link']}
                  icon={faArrowUpRightFromSquare}
                  onClick={trackLearnMoreClick}
                >
                  <Text textType={TextType.Caption} value={messages.learnMore} />
                </HelpArticleLink>
              </FlexRow>
              <Divider className={style.divider} />
              <AutomationTools />
            </FlexColumn>
          </FlexColumn>
        </div>
      </FilterEditorContextProvider>
    </AutomationRulesProvider>
  );
};
